import React from 'react';
import { NotificationManager } from '@atlas/core';

const subscribeUserOffline = () => {
  window.addEventListener('offline', () => {
    NotificationManager.notify({
      type: 'notification',
      status: 'warning',
      message: 'lost_internet_connection',
    });
  });
};

export default subscribeUserOffline;
